import { render } from "./PwRecovery.vue?vue&type=template&id=a0c85eae&scoped=true"
import script from "./PwRecovery.vue?vue&type=script&lang=js"
export * from "./PwRecovery.vue?vue&type=script&lang=js"

import "./PwRecovery.vue?vue&type=style&index=0&id=a0c85eae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c85eae"]])

export default __exports__